"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AUTHENTICATING = exports.AUTHENTICATING = "AUTHENTICATING";
var AUTHENTICATED = exports.AUTHENTICATED = "AUTHENTICATED";
var SEND_OTP_STARTED = exports.SEND_OTP_STARTED = "SEND_OTP_STARTED";
var SEND_OTP_COMPLETED = exports.SEND_OTP_COMPLETED = "SEND_OTP_COMPLETED";
var AUTHENTICATION_FAILED = exports.AUTHENTICATION_FAILED = "AUTHENTICATION_FAILED";
var USER_PROFILE_UPDATED = exports.USER_PROFILE_UPDATED = "USER_PROFILE_UPDATED";
var USER_PROFILE_UPDATE_ERROR = exports.USER_PROFILE_UPDATE_ERROR = "USER_PROFILE_UPDATE_ERROR";
var USER_SEARCH_SUCCESS = exports.USER_SEARCH_SUCCESS = "USER_SEARCH_SUCCESS";
var USER_SEARCH_ERROR = exports.USER_SEARCH_ERROR = "USER_SEARCH_ERROR";
var LOGOUT = exports.LOGOUT = "LOGOUT";


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/redux/auth/actionTypes.js
// module id = 1427
// module chunks = 895